var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup35789(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35789",
    transform: "translate(-678 -1498)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 346",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(678 1498)",
    style: {
      opacity: 0.2,
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34624"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41384",
    d: "M994.554 175.812c-.423-.071-.979.154-1.068-.519-.048-.365.145-.469 1-.593v-1.018h-.614c-.408 0-.647-.2-.652-.521s.236-.53.636-.535h.619a1.535 1.535 0 0 0-.728-1.113 5.479 5.479 0 0 1-2.093-2.909 5.633 5.633 0 0 1 1.465-5.951 5.389 5.389 0 0 1 5.864-1.312 5.464 5.464 0 0 1 3.829 4.711 5.621 5.621 0 0 1-2.247 5.408 1.886 1.886 0 0 0-.8 1.166h.659a.531.531 0 1 1-.008 1.055c-.2.006-.395.006-.592.01-.01 0-.02.01-.058.03v1.016c.167 0 .327-.008.486 0a.521.521 0 0 1 .524.54.482.482 0 0 1-.516.5c-.461-.057-.612.158-.77.555A2.538 2.538 0 0 1 997 177.9a2.624 2.624 0 0 1-2.324-1.739c-.042-.105-.076-.216-.122-.349zm4.149-3.205a3.009 3.009 0 0 1 1.3-2.044 4.758 4.758 0 0 0 1.392-5.753 4.682 4.682 0 0 0-5.258-2.636 4.458 4.458 0 0 0-3.582 3.568 4.618 4.618 0 0 0 1.721 4.851 4.125 4.125 0 0 1 .838.831 7.313 7.313 0 0 1 .526 1.183zm-3.132 2.1h3.1v-1h-3.1zm.114 1.1a1.51 1.51 0 0 0 1.5 1.042 1.458 1.458 0 0 0 1.367-1.042z",
    transform: "translate(-304.128 1343.557)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41385",
    d: "M987.948 168.477a4.59 4.59 0 0 1 .572 0 .5.5 0 0 1 .48.528.489.489 0 0 1-.478.527 8.259 8.259 0 0 1-1.179 0 .488.488 0 0 1-.479-.526.5.5 0 0 1 .478-.529 4.879 4.879 0 0 1 .606 0z",
    transform: "translate(-302.869 1341.366)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41386",
    d: "M1010.379 169.542a4.315 4.315 0 0 1-.571-.005.5.5 0 0 1-.478-.53.489.489 0 0 1 .48-.525 8.355 8.355 0 0 1 1.179 0 .488.488 0 0 1 .478.527.5.5 0 0 1-.48.528 4.875 4.875 0 0 1-.608.005z",
    transform: "translate(-309.46 1341.368)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41387",
    d: "M1008.438 164.239c-.2-.179-.44-.289-.48-.447a.689.689 0 0 1 .151-.592 4.033 4.033 0 0 1 1.076-.62.655.655 0 0 1 .58.174c.1.12.125.493.032.568a15.966 15.966 0 0 1-1.359.917z",
    transform: "translate(-309.073 1343.115)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41388",
    d: "M988.94 175.318c-.1-.1-.329-.218-.363-.38a.709.709 0 0 1 .178-.588 5.044 5.044 0 0 1 1.009-.6.489.489 0 0 1 .661.179.466.466 0 0 1-.076.675 13.231 13.231 0 0 1-1.167.681.99.99 0 0 1-.242.033z",
    transform: "translate(-303.346 1339.833)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41389",
    d: "M1009.864 174.663c.012.484-.37.759-.733.586a8.732 8.732 0 0 1-1.021-.584.492.492 0 0 1-.164-.692.469.469 0 0 1 .639-.236 8.936 8.936 0 0 1 1.107.643c.103.068.142.231.172.283z",
    transform: "translate(-309.052 1339.834)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41390",
    d: "M990.5 163.477c0 .509-.4.764-.787.574a9.717 9.717 0 0 1-.957-.553.529.529 0 0 1-.177-.72.518.518 0 0 1 .713-.2 8.863 8.863 0 0 1 .954.557 1.123 1.123 0 0 1 .254.342z",
    transform: "translate(-303.329 1343.129)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41391",
    d: "M998.919 170.436c.633-.634 1.194-1.2 1.756-1.761.195-.195.442-.305.669-.125a.929.929 0 0 1 .269.527c.02.107-.091.267-.185.363q-1.012 1.033-2.044 2.047a.531.531 0 0 1-.846.01c-.336-.32-.663-.651-.986-.984a.554.554 0 0 1-.059-.8.547.547 0 0 1 .821.038c.1.1.208.2.3.3s.186.228.305.385z",
    transform: "translate(-305.968 1341.354)",
    style: {
      fill: "#5f7d95"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup35789);
export default __webpack_public_path__ + "static/media/Group35789.fc67ef991eaf8735945e42951975f48a.svg";
export { ForwardRef as ReactComponent };